// One label/value line inside a `.visitor-card` — RON-5466.
//
// Extracted from VisitorReviewStep in Phase 3 so the View screen presents a visit in exactly the
// same shape the wizard reviewed it in. Two screens rendering the same facts differently is how
// "the review said Block A but the detail says Block B" bugs start.

const VisitorDetailRow = ({ label, value }) => (
  <div className="visitor-detail-row">
    <span className="visitor-detail-row__label">{label}</span>
    <span className="visitor-detail-row__value">{value}</span>
  </div>
);

export default VisitorDetailRow;
